import React, { useEffect, useState } from 'react';
import { fetchAllArtworks } from '../../api/artworks';
import ArtworkCard from './ArtworkCard';

const ArtworkList: React.FC = () => {
    const [artworks, setArtworks] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const loadArtworks = async () => {
            try {
                const data = await fetchAllArtworks();
                setArtworks(data);
            } catch (err) {
                setError('Failed to load artworks');
            } finally {
                setLoading(false);
            }
        };

        loadArtworks();
    }, []);

    if (loading) {
        return (
            <div className="flex flex-col items-center py-20 animate-pulse">
                <div className="w-10 h-10 border-2 border-accent border-t-transparent rounded-full animate-spin mb-4"></div>
                <p className="text-gray-400 font-serif italic text-lg tracking-widest">Collecting masterpieces...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="text-center py-20 bg-red-50 rounded-sm border border-red-100">
                <p className="text-red-800 font-serif mb-2">Excuses, de collectie kon niet worden geladen.</p>
                <p className="text-red-400 text-xs uppercase tracking-widest">{error}</p>
            </div>
        );
    }

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-24">
            {artworks.map((artwork) => (
                <ArtworkCard
                    key={artwork._id}
                    id={artwork._id}
                    title={artwork.title}
                    imageUrl={artwork.imageUrl}
                    images={artwork.images}
                    price={artwork.price}
                    description={artwork.description}
                    year={artwork.year}
                    type={artwork.type}
                    status={artwork.status}
                />
            ))}
        </div>
    );
};

export default ArtworkList;